import { TemplateObjectType } from 'webapp/enums/enums';

import type { Args } from 'webapp/components/templates/recommended-base';
import TemplatesPublicRecommendedBaseComponent from 'webapp/components/templates/recommended-base';

import type Template from 'webapp/models-custom/template';

export default class TemplatesAccountRecommendedComponent<
	T extends Args,
> extends TemplatesPublicRecommendedBaseComponent<T> {
	redirectRoute = 'boards.account-templates';
	defaultOrigin = 'recommended_account_templates';
	override isLinkShown = false;

	override get title() {
		return this.accountService.isClient
			? 'Use templates made in the organization...'
			: super.title;
	}

	get model(): Template[] {
		return this.mmTemplatesService.getRecommendedAccountTemplateModels(Infinity);
	}

	override get isShown() {
		return !this.currentUserService.isViewer;
	}

	requestTemplates() {
		const promises = [
			this.mmTemplatesService.requestBoardAccountTemplates(),
			this.mmTemplatesService.requestBoardLoopAccountTemplates(),
		];

		return Promise.allSettled(promises);
	}

	onTemplateUse(model: Template): void {
		if (model.objectType === TemplateObjectType.BOARD) {
			this.onBoardTemplateUse(model);
		} else if (model.objectType === TemplateObjectType.BOARD_LOOP) {
			this.onBoardLoopTemplateUse(model);
		}
	}
}
